import React, { Fragment, useContext, useEffect, useState } from "react";
import { Alert, Card, CardBody, Col, FormGroup, Label, Row } from "reactstrap";
import { format, parseISO } from "date-fns";
import {
  errorInvalidaDate,
  PersonalDataTitle,
} from "../../../../Shared/Constants";
import { H3 } from "../../../../AbstractElements";
import { useTranslation } from "react-i18next";
import { ContactContext, PersonalDataContext } from "../../ContextProvider";
import { getPoliticSpacesApi } from "../../../../Shared/Api/GetPoliticSpaces";
import { getBlocksApi } from "../../../../Shared/Api/GetBlocks";
import { getDistrictsApi } from "../../../../Shared/Api/GetDistricts";
import InputError from "../../../../Shared/Components/Form/InputError";
import { getJurisdictionsApi } from "../../../../Shared/Api/GetJurisdictions";
import { isValidDate } from "../../../../Shared/Utils/dateUtils";
import CustomSelect from "../../../../Shared/Components/Form/CustomSelect";
import { getComissionsApi } from "../../../../Shared/Api/GetComissions";

import CustomMultipleSelect from "../../../../Shared/Components/Form/CustomMultipleSelect";
import { getAreasApi } from "../../../../Shared/Api/GetAreas";

const PersonalData = ({ contactId, register, errors, setValue }) => {
  const { t } = useTranslation("translation");

  //state
  const [jurisdictions, setJurisdictions] = useState([]);
  const [politicSpaces, setPoliticSpaces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [areas, setAreas] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [comissions, setComissions] = useState([]);

  //context
  const { item: contactData } = useContext(ContactContext);
  const { item, apiErrors, setItem, getItem, setApiErrors } =
    useContext(PersonalDataContext);

  //alert
  const [alertOpen, setAlertOpen] = useState(
    apiErrors && apiErrors.length > 0 ? true : false
  );

  const ToggleAlert = () => setAlertOpen(!alertOpen);

  //usefect
  useEffect(() => {
    setAlertOpen(apiErrors && apiErrors.length > 0 ? true : false);
  }, [apiErrors]);

  /// manejos del componente
  const fetchJurisdictions = async () => {
    let response = await getJurisdictionsApi();
    if (response.result === "success") {
      setJurisdictions(response.data?.items);
    }
  };
  const fetchPoliticSpaces = async () => {
    let response = await getPoliticSpacesApi();
    if (response.result === "success") {
      setPoliticSpaces(response.data?.items);
    }
  };
  const fetchDistricts = async () => {
    let response = await getDistrictsApi();
    if (response.result === "success") {
      setDistricts(response.data?.items);
    }
  };
  const fetchAreas = async () => {
    let response = await getAreasApi();
    if (response.result === "success") {
      setAreas(response.data?.items);
    }
  };
  const fetchBlocks = async () => {
    let response = await getBlocksApi({
      jurisdiction_id: item.jurisdiction_id,
    });
    if (response.result === "success") {
      setBlocks(response.data?.items);
    }
  };
  const fetchComissions = async () => {
    let response = await getComissionsApi({
      jurisdiction_id: item.jurisdiction_id,
    });
    if (response.result === "success") {
      setComissions(response.data?.items);
    }
  };
  useEffect(() => {
    fetchJurisdictions();
    fetchPoliticSpaces();
    fetchDistricts();
    fetchBlocks();
    fetchAreas();
  }, []);

  useEffect(() => {
    setValue("jurisdiction_id", item?.jurisdiction_id);
    setValue("politic_space_id", item?.politic_space_id);
    setValue("district_id", item?.district_id);
    setValue("area_id", item?.area_id);
    setValue("block_id", item?.block_id);
    setValue("profile_url", item?.profile_url);
    setValue("comissions", item?.comissions);

    setValue(
      "charge_end_at",
      item?.charge_end_at
        ? format(parseISO(item.charge_end_at), "yyyy-MM-dd")
        : null
    ); //2024-01-01
    setValue(
      "charge_start_at",
      item?.charge_start_at
        ? format(parseISO(item.charge_start_at), "yyyy-MM-dd")
        : null
    );

    if (item?.jurisdiction_id) {
      fetchBlocks();
      fetchComissions();
    }
  }, [item]);

  useEffect(() => {
    contactId ? getItem(contactId) : setItem({});
  }, [contactId]);

  useEffect(() => {
    setValue("contact_id", contactData?.id);
  }, [contactData]);

  useEffect(() => {
    return () => {
      setItem({});
      setApiErrors([]);
    };
  }, []);
  const handleChangeJurisdiction = async (e) => {
    if (e?.id) {
      item.jurisdiction_id = e?.id;
      fetchComissions();
      fetchBlocks();
    }
  };
  return (
    <Fragment>
      <Card>
        <CardBody>
          <Alert
            className="alert-dismissible"
            color="danger inverse"
            isOpen={alertOpen}
            toggle={ToggleAlert}
          >
            <i class="icon-alert"></i>
            {apiErrors && apiErrors.length > 0 ? apiErrors[0] : ""}
          </Alert>

          <H3>{PersonalDataTitle}</H3>

          <input
            className={`form-control ${errors.contact_id && "is-invalid"}`}
            type="hidden"
            required="true"
            autoComplete="off"
            {...register("contact_id", {})}
          />
          <div className="product-group">
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label htmlFor="jurisdiction_id" className="form-label">
                    {t("Jurisdiccion")}
                  </Label>

                  <CustomSelect
                    customChangeHandler={handleChangeJurisdiction}
                    items={jurisdictions}
                    name={"jurisdiction_id"}
                    setValue={setValue}
                    placeholder="Seleccione"
                    errors={errors}
                    register={register}
                    item={item}
                  />

                  <InputError errors={errors} name="jurisdiction_id" />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label
                    htmlFor="exampleFormControlSelect4"
                    className="form-label"
                  >
                    {t("Espacio politico")}
                  </Label>
                  <CustomSelect
                    items={politicSpaces}
                    name={"politic_space_id"}
                    setValue={setValue}
                    placeholder="Seleccione"
                    errors={errors}
                    register={register}
                    item={item}
                  />

                  <InputError errors={errors} name="politic_space_id" />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label
                    htmlFor="exampleFormControlSelect4"
                    className="form-label"
                  >
                    {t("Distrito")}
                  </Label>

                  <CustomSelect
                    items={districts}
                    name={"district_id"}
                    setValue={setValue}
                    placeholder="Seleccione"
                    errors={errors}
                    register={register}
                    item={item}
                  />

                  <InputError errors={errors} name="district_id" />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label
                    htmlFor="exampleFormControlSelect4"
                    className="form-label"
                  >
                    {t("Bloque")}
                  </Label>

                  <CustomSelect
                    items={blocks}
                    name={"block_id"}
                    setValue={setValue}
                    placeholder="Seleccione"
                    errors={errors}
                    register={register}
                    item={item}
                  />

                  <InputError errors={errors} name="block_id" />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              {(contactData?.charge?.name == "DIPUTADO" ||
                contactData?.charge?.name == "SENADOR") && (
                <Col md="6">
                  <FormGroup>
                    <Label
                      htmlFor="exampleFormControlSelect4"
                      className="form-label"
                    >
                      {t("Comision")}
                    </Label>

                    <CustomMultipleSelect
                      register={register}
                      setValue={setValue}
                      items={comissions}
                      name={"comissions"}
                      placeholder="Seleccione"
                      errors={errors}
                      item={contactData}
                    />
                  </FormGroup>
                </Col>
              )}
            </Row>
            <Row>
              {contactData?.charge?.name == "ASESOR" && (
                <Col md="6">
                  <FormGroup>
                    <Label
                      htmlFor="exampleFormControlSelect4"
                      className="form-label"
                    >
                      {t("AREA")}
                    </Label>

                    <CustomSelect
                      items={areas}
                      name={"area_id"}
                      setValue={setValue}
                      placeholder="Seleccione"
                      errors={errors}
                      register={register}
                      item={item}
                    />
                  </FormGroup>
                </Col>
              )}
            </Row>
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label className="charge_start_at">Inicio de mandato</Label>

                  <input
                    className={`form-control digits ${
                      errors.first_name && "is-invalid"
                    }`}
                    type="date"
                    placeholder="01/01/2024"
                    autoComplete="off"
                    {...register("charge_start_at", {
                      valueAsDate: true,
                      required: false,

                      validate: (value) =>
                        isValidDate(value) || errorInvalidaDate,
                    })}
                  />
                  <InputError errors={errors} name="charge_start_at" />
                </FormGroup>
              </Col>
              {(contactData?.charge?.name == "DIPUTADO" ||
                contactData?.charge?.name == "SENADOR") && (
                <Col md="6">
                  <FormGroup>
                    <Label className="charge_end_at">Fin de mandato</Label>

                    <input
                      className={`form-control digits ${
                        errors.first_name && "is-invalid"
                      }`}
                      type="date"
                      placeholder="01/01/2025"
                      autoComplete="off"
                      {...register("charge_end_at", {
                        valueAsDate: true,

                        validate: (value) =>
                          isValidDate(value) || errorInvalidaDate,
                      })}
                    />
                    <InputError errors={errors} name="charge_end_at" />
                  </FormGroup>
                </Col>
              )}
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label> {t("Link perfil")}</Label>
                  <input
                    className={`form-control ${
                      errors.profile_url && "is-invalid"
                    }`}
                    type="text"
                    required=""
                    placeholder="https://ejemplo.com"
                    autoComplete="off"
                    {...register("profile_url", {
                      pattern: {
                        value:
                          /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\/.*)?$/,
                        message:
                          "La URL debe comenzar con http:// o https:// y ser válida",
                      },
                    })}
                  />
                  <InputError errors={errors} name="profile_url" />
                </FormGroup>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};
export default PersonalData;
